
import appConfig from 'configs/app.config'
import { createServer } from 'miragejs'
import {
    accountFormData,
    invoiceData,
    logData,
    settingBillingData,
    settingData,
    settingIntergrationData
} from './data/accountData'
import { signInUserData } from './data/authData'
import { notificationListData, searchQueryPoolData } from './data/commonData'
import { crmDashboardData, eventsData, mailData } from './data/crmData'
import { cryptoDashboardData, marketData, portfolioData, transactionHistoryData, walletsData } from './data/cryptoData'
import { helpCenterArticleListData, helpCenterCategoriesData } from './data/knowledgeBaseData'
import { issueData, projectDashboardData, projectList, scrumboardData } from './data/projectData'
import { orderDetailsData, ordersData, productsData, salesDashboardData } from './data/salesData'
import { userDetailData, usersData } from './data/usersData'

import {
    accountFakeApi,
    authFakeApi,
    commonFakeApi,
    crmFakeApi,
    cryptoFakeApi,
    knowledgeBaseFakeApi,
    projectFakeApi,
    salesFakeApi
} from './fakeApi'

const { apiPrefix } = appConfig

export default function mockServer({ environment = 'test' }) {
    console.log('🔧 Mock server started in', environment, 'environment')
    return createServer({
        environment,
        seeds(server) {
			server.db.loadData({
				notificationListData,
                searchQueryPoolData,
                projectList,
                scrumboardData,
                issueData,
                usersData,
                userDetailData,
                eventsData,
                mailData,
                productsData,
                ordersData,
                orderDetailsData,
                settingData,
                settingIntergrationData,
                settingBillingData,
                invoiceData,
                logData,
                accountFormData,
                portfolioData,
                walletsData,
                marketData,
                transactionHistoryData,
                helpCenterCategoriesData,
                helpCenterArticleListData,
                signInUserData,
                salesDashboardData,
                crmDashboardData,
                projectDashboardData,
                cryptoDashboardData
			})
		},
        routes() {
            this.urlPrefix = ''
            this.namespace = ''
            this.passthrough('http://192.168.1.22:3001/**')

            this.passthrough()
            
            commonFakeApi(this, apiPrefix)
            projectFakeApi(this, apiPrefix)
            crmFakeApi(this, apiPrefix)
            salesFakeApi(this, apiPrefix)
            accountFakeApi(this, apiPrefix)
            authFakeApi(this, apiPrefix)
            cryptoFakeApi(this, apiPrefix)
            knowledgeBaseFakeApi(this, apiPrefix)
        },
    })
}